import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Form, Alert } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { doc, setDoc, Timestamp } from "firebase/firestore";
import { useUserAuth } from "../context/UserAuthContext";
import { db } from "../firebase";

const Signup = () => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [password, setPassword] = useState("");
    const { signUp } = useUserAuth();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        try {
            const result = await signUp(email, password);
            const uid = result.user.uid;

            if (token) {
                // Invited user — redirect to accept invite flow
                navigate(`/accept-invite?token=${token}`);
            } else {
                // New admin user — create user doc + org doc
                await setDoc(doc(db, "users", uid), {
                    role: "admin",
                    orgId: uid,
                    email: email,
                });
                await setDoc(doc(db, "organizations", uid), {
                    portalId: null,
                    slackTeamId: null,
                    agentIds: [],
                    members: [],
                    currencyCode: "USD",
                    createdAt: Timestamp.now(),
                });
                navigate("/auth");
            }
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <>
            <div className="p-4 box">
                <h2 className="mb-3">Create an Account</h2>
                {token && (
                    <Alert variant="info">You've been invited to join a team. Sign up to accept.</Alert>
                )}

                {error && <Alert variant="danger">{error}</Alert>}

                <Form onSubmit={handleSubmit}>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control
                            type="email"
                            placeholder="Email address"
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Control
                            type="password"
                            placeholder="Password"
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </Form.Group>

                    <div className="d-grid gap-2">
                        <Button variant="primary" type="Submit">
                            Sign up
                        </Button>
                    </div>
                </Form>
            </div>
            <div className="p-4 box mt-3 text-center">
                Already have an account? <Link to="/">Log In</Link>
            </div>
        </>
    );
};

export default Signup;
